export * from './networkHierarchyServiceResource.service';
export * from './nodeServiceResource.service';
import { NetworkHierarchyServiceResourceService } from './networkHierarchyServiceResource.service';
import { NodeServiceResourceService } from './nodeServiceResource.service';
export const APIS = [NetworkHierarchyServiceResourceService, NodeServiceResourceService]